<template>
  <div class="process">
    <div class="title">
      <img src="@/assets/pc/images/biaoti@2x.png" />
      <div class="shuoming">乐托品正品货源说明</div>
    </div>
    <div class="head">
      <img src="@/assets/pc/images/shoutu@2x.png" />
      <div class="head-content">
        <div class="content-title">
          五洲藥物國際貿易有限公司
        </div>
        <div class="content-desc">
          乐托品大中华地区（中国大陆，中国香港，中国澳门）独家经销商
        </div>
        <div class="content-detail">
          五洲药物国际贸易有限公司（简称五洲药物）是一家位于中国澳门，
          专注于开发高效的医疗产品，为患者提供科学性突破疗法的药品
          经销商。自成立以来，五洲药物通过提供全球领先的药品组合，
          为中国数百万患者解决健康问题。
        </div>
      </div>
    </div>
    <div class="display-center tedian">
      <div class="tedian-item">
        <img src="@/assets/pc/images/huanzhe@2x.png" />
        <div class="tedian-name">
          以患者为中心
        </div>
      </div>
      <div class="tedian-item">
        <img src="@/assets/pc/images/yaopinguige@2x.png" />
        <div class="tedian-name">
          多个独家产品
        </div>
      </div>
      <div class="tedian-item">
        <img src="@/assets/pc/images/xuekelingyu@2x.png" />
        <div class="tedian-name">
          多种治疗领域
        </div>
      </div>
    </div>
    <div class="cert">
      <div class="cert-title">五洲公司资质书</div>
      <div class="display-center cert-list">
        <div class="cert-item" v-for="(item, index) in urls" :key="index">
          <el-image :src="item" :preview-src-list="srcList"></el-image>
        </div>
      </div>
    </div>
    <div class="cert">
      <div class="cert-title">乐托品授权书</div>
      <div class="display-center   cert-list">
        <div
          class="cert-item cert-book"
          v-for="(item, index) in latropineUrls"
          :key="index"
        >
          <el-image :src="item.url" :preview-src-list="srcList"></el-image>
          <div class="cert-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="title lianlu-title">
      <img src="@/assets/pc/images/biaoti@2x.png" />
      <div class="shuoming">乐托品正品链路说明</div>
    </div>
    <div class="sub-title">
      <img src="@/assets/pc/images/01@2x.png" />
      <div class="sub-content">
        由台湾五福出货直发至五洲药物的澳门仓库
      </div>
    </div>
    <div class="cert-list">
      <div class="cert-container">
        <div class="fahuo-name label">五福发货凭证</div>
        <div class="cert-images">
          <div
            class="container-item"
            v-for="(item, index) in fahuoUrls"
            :key="index"
          >
            <el-image :src="item" :preview-src-list="srcList"></el-image>
          </div>
        </div>
      </div>
      <div class="cert-container">
        <div class="fahuo-name label">五洲的药品牌照</div>
        <div class="container-item">
          <el-image :src="paizhaoUrl" :preview-src-list="srcList"></el-image>
        </div>
      </div>
    </div>
    <div class="sub-title hezuocang">
      <img src="@/assets/pc/images/02@2x.png" />
      <div class="sub-content">
        澳门转口至香港合作仓
      </div>
    </div>
    <div class="cert-list">
      <div class="cert-container">
        <div class="jinkou-name label">乐托品澳门上市证明</div>
        <div class="container-item">
          <el-image :src="shangshiUrl" :preview-src-list="srcList"></el-image>
        </div>
      </div>
      <div class="cert-container">
        <div class="jinkou-name label">乐托品的预先进口许可证</div>
        <div class="container-item">
          <el-image :src="jinkouUrl" :preview-src-list="srcList"></el-image>
        </div>
      </div>
    </div>
    <div class="sub-title zhiyou-title">
      <img src="@/assets/pc/images/03@2x.png" />
      <div class="sub-content">
        香港合作仓直邮客户
      </div>
    </div>
    <div class="cert-list">
      <div class="cert-container">
        <div class="hezuo-name label">香港合作仓库的商业许可证</div>
        <div class="container-item">
          <el-image :src="cangkuUrl" :preview-src-list="srcList"></el-image>
        </div>
      </div>
      <div class="cert-container">
        <div class="hezuo-name label">乐托品清关进口凭证</div>
        <div class="container-item">
          <el-image :src="qingguanUrl" :preview-src-list="srcList"></el-image>
        </div>
      </div>
    </div>
    <div class="process-footer">
      <img src="@/assets/pc/images/xinlai@2x.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Process",
  components: {},
  data() {
    return {
      urls: [
        require("@/assets/pc/images/wuzhou1@2x.png"),
        require("@/assets/pc/images/wuzhou2@2x.png"),
        require("@/assets/pc/images/wuzhou3@2x.png")
      ],
      latropineUrls: [
        {
          url: require("@/assets/pc/images/0.01@2x.png"),
          name: "0.01%乐托品授权书"
        },
        {
          url: require("@/assets/pc/images/0.02@2x.png"),
          name: "0.02%乐托品授权书"
        }
      ],
      fahuoUrls: [
        require("@/assets/pc/images/wufu1@2x.png"),
        require("@/assets/pc/images/wufu2@2x.png")
      ],
      paizhaoUrl: require("@/assets/pc/images/wuzhouyp@2x.png"),
      shangshiUrl: require("@/assets/pc/images/ltpamss@2x.png"),
      jinkouUrl: require("@/assets/pc/images/jckxkz@2x.png"),
      cangkuUrl: require("@/assets/pc/images/ckxkz@2x.png"),
      qingguanUrl: require("@/assets/pc/images/qingguanz@2x.png"),
      srcList: [
        require("@/assets/pc/images/wuzhou1@2x.png"),
        require("@/assets/pc/images/wuzhou2@2x.png"),
        require("@/assets/pc/images/wuzhou3@2x.png"),
        require("@/assets/pc/images/0.01@2x.png"),
        require("@/assets/pc/images/0.02@2x.png"),
        require("@/assets/pc/images/wufu1@2x.png"),
        require("@/assets/pc/images/wufu2@2x.png"),
        require("@/assets/pc/images/wuzhouyp@2x.png"),
        require("@/assets/pc/images/ltpamss@2x.png"),
        require("@/assets/pc/images/jckxkz@2x.png"),
        require("@/assets/pc/images/ckxkz@2x.png"),
        require("@/assets/pc/images/qingguanz@2x.png")
      ]
    };
  },
  methods: {},
  created() {},
  mounted() {},
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.process {
  width: 100%;
  &-footer {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .title {
    width: 68%;
    margin: 0 auto;
    margin-top: 0.3rem;
    margin-bottom: 0.4rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .shuoming {
      position: absolute;
      font-size: 0.3rem;
      color: rgb(59, 173, 227);
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .head {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    &-content {
      position: absolute;
      width: 94%;
      padding: 0.2rem;
      box-sizing: border-box;
      background-color: rgb(61, 139, 237);
      color: #ffffff;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%) translateY(80%);
      .content-title {
        font-size: 0.4rem;
      }
      .content-desc {
        margin-top: 6px;
        margin-bottom: 10px;
      }
      .content-detail {
        font-size: 0.4px;
        line-height: 0.4rem;
        font-weight: lighter;
      }
    }
  }
  .display-center {
    display: flex;
    align-items: center;
  }
  .tedian {
    justify-content: space-around;
    margin-top: 3.3rem;
    &-item {
      text-align: center;
      img {
        width: 1.7rem;
      }
    }
    &-name {
      font-size: 0.3rem;
      font-weight: 600;
    }
  }
  .cert {
    margin-top: 0.5rem;
    &-title {
      background-color: rgb(61, 139, 237);
      color: #ffffff;
      width: 3.5rem;
      font-size: 0.4rem;
      padding: 0.1rem;
      margin: 0 auto;
      margin-bottom: 0.3rem;
      text-align: center;
    }
    &-list {
      justify-content: space-around;
      padding: 0 0.1rem;
    }
    &-item {
      width: 30%;
      img {
        width: 100%;
      }
    }
    &-book {
      width: 49%;
    }
    &-name {
      text-align: center;
    }
    // &-images {
    // }
  }
  .container-item {
    padding: 0 10px;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }
  .label {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    margin: 0 auto;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
  .fahuo-name {
    width: 180px;
    background-color: rgb(110, 187, 71);
  }
  .jinkou-name {
    background-color: rgb(225, 59, 61);
    width: 280px;
  }
  .hezuo-name {
    background-color: rgb(59, 173, 227);
    width: 280px;
  }
  .lianlu-title {
    width: 56%;
  }
  .sub-title {
    width: 99%;
    position: relative;
    padding: 0 0.1rem;
    box-sizing: border-box;
    img {
      width: 100%;
    }
    .sub-content {
      position: absolute;
      right: 0.3rem;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-size: 0.3rem;
    }
  }
  .hezuocang {
    width: 64%;
  }
  .zhiyou-title {
    width: 60%;
  }
}
</style>
